import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogCustomAnnotationDropdownTriggerListItem from './VeltCommentDialogCustomAnnotationDropdownTriggerListItem/VeltCommentDialogCustomAnnotationDropdownTriggerListItem';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogCustomAnnotationDropdownTriggerList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownTriggerList.Item = VeltCommentDialogCustomAnnotationDropdownTriggerListItem;
export default VeltCommentDialogCustomAnnotationDropdownTriggerList;
